import {
  MANANGE_LISTING_PUBLISH_STATUS_START,
  MANANGE_LISTING_PUBLISH_STATUS_SUCCESS,
  MANANGE_LISTING_PUBLISH_STATUS_ERROR,
} from '../../constants';
import { sendEmail } from '../../core/email/sendEmail';
import { sendNotifications } from '../../helpers/sendNotifications';
import { getSpecificConfig } from '../../helpers/getConfigValue';
import showToaster from '../../helpers/showToaster';
import {
  ListingQuery, ManageListingQuery, getUpcomingBookingQuery, ListingStepsQuery,
  ManagePublish, wishListStatus, submitForVerificationMutation, approveListingMutation, createHistory
} from '../../lib/graphql';
import { demoRestriction } from '../../helpers/DemoRestriction/demoRestriction';

export function ManagePublishStatus(listId, action) {

  return async (dispatch, getState, { client }) => {

    const isRestrict = await dispatch(demoRestriction({ restrictType: 'listing', restrictValue: listId }));
    if (isRestrict) return;

    dispatch({
      type: MANANGE_LISTING_PUBLISH_STATUS_START,
      payload: {
        publishListLoading: true
      }
    });

    let upcomingBookingCount;
    const bookedData = await client.query({
      query: getUpcomingBookingQuery,
      variables: {
        listId
      },
      fetchPolicy: 'network-only'
    });

    if (bookedData?.data?.getUpcomingBookings) {
      upcomingBookingCount = bookedData.data.getUpcomingBookings.count;
    }

    try {

      let type = 'Publish Listing';
      if (action === 'unPublish') {
        type = 'UnPublish Listing'
      }

      if (upcomingBookingCount > 0 && action === 'unPublish') {
        showToaster({ messageId: 'unPublish', toasterType: 'error' })
        dispatch({
          type: MANANGE_LISTING_PUBLISH_STATUS_ERROR,
          payload: {
            publishListLoading: false
          }
        });
      } else {

        const { data } = await client.mutate({
          mutation: ManagePublish,
          variables: {
            listId,
            action
          },
          refetchQueries: [
            { query: ManageListingQuery },
          ]
        });

        if (data?.managePublish?.status === '200') {

          const { dataList } = await client.mutate({
            mutation: wishListStatus,
            variables: {
              listId,
              action
            },
          });

          // Reload Existing Steps Page
          const { data } = await client.query({
            query: ListingStepsQuery,
            variables: { listId: String(listId) },
            fetchPolicy: 'network-only',
          });
          showToaster({ messageId: 'publishSuccess', toasterType: 'success', requestContent: type })
          dispatch({
            type: MANANGE_LISTING_PUBLISH_STATUS_SUCCESS,
            payload: {
              listingSteps: data.showListingSteps,
              publishListLoading: false
            }
          });
        } else {
          showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: `${type} is failed` })
          dispatch({
            type: MANANGE_LISTING_PUBLISH_STATUS_ERROR,
            payload: {
              status: data.managePublish.status,
              publishListLoading: false
            }
          });
        }
      }
    } catch (error) {
      dispatch({
        type: MANANGE_LISTING_PUBLISH_STATUS_ERROR,
        payload: {
          error,
          publishListLoading: false
        }
      });
    }
  };
}

export function submitForVerification(listId, listApprovalStatus) {

  return async (dispatch, getState, { client }) => {
    dispatch({
      type: MANANGE_LISTING_PUBLISH_STATUS_START,
      payload: {
        publishListLoading: true
      }
    });

    try {
      const dataListingQuery = await client.query({
        query: ListingQuery,
        variables: {
          listId: Number(listId),
          preview: true
        },
        fetchPolicy: 'network-only',
      });

      const { data } = await client.mutate({
        mutation: submitForVerificationMutation,
        variables: {
          id: listId,
          listApprovalStatus
        }
      });
      if (data?.submitForVerification?.status == "200") {
        // Reload Existing Steps Page
        const { data } = await client.query({
          query: ListingStepsQuery,
          variables: { listId: String(listId) },
          fetchPolicy: 'network-only',
        });

        dispatch({
          type: MANANGE_LISTING_PUBLISH_STATUS_SUCCESS,
          payload: {
            listingSteps: data.showListingSteps,
            publishListLoading: false
          }
        });

        if (dataListingQuery?.data?.UserListing) {
          let listDetails = dataListingQuery.data.UserListing;
          let content = {
            listId: listDetails.id,
            listTitle: listDetails.title,
            hostName: listDetails.user.profile.firstName,
          }
          showToaster({ messageId: 'createListing', toasterType: 'success' })

          const { data } = await client.mutate({
            mutation: createHistory,
            variables: {
              listId,
              userId: listDetails.userId,
              status: "submitForverification",
            }
          });

          const configData = await getSpecificConfig({ name: ['email'] });

          sendEmail(configData.email, 'listPublishRequest', content);

        }
      } else {
        showToaster({ messageId: 'actionFailed', toasterType: 'error' })
        dispatch({
          type: MANANGE_LISTING_PUBLISH_STATUS_ERROR,
          payload: {
            status: data.managePublish.status,
            publishListLoading: false
          }
        });
      }

    } catch (error) {
      dispatch({
        type: MANANGE_LISTING_PUBLISH_STATUS_ERROR,
        payload: {
          error,
          publishListLoading: false
        }
      });
    }
  };
}

export function approveListing(listId, listApprovalStatus, reason) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: MANANGE_LISTING_PUBLISH_STATUS_START,
      payload: {
        publishListLoading: true
      }
    });

    try {
      const dataListingQuery = await client.query({
        query: ListingQuery,
        variables: {
          listId: Number(listId),
          preview: true
        },
        fetchPolicy: 'network-only',
      });

      const { data } = await client.mutate({
        mutation: approveListingMutation,
        variables: {
          id: listId,
          listApprovalStatus
        },
      });
      if (data?.approveListing?.status === "200") {
        const { data } = await client.query({
          query: ListingStepsQuery,
          variables: { listId: String(listId) },
          fetchPolicy: 'network-only',
        });

        if (dataListingQuery?.data?.UserListing) {
          let listDetails = dataListingQuery.data.UserListing;
          let content = {
            listId: listDetails.id,
            listTitle: listDetails.title,
            hostName: listDetails.user.profile.firstName,
            reason: listApprovalStatus === 'declined' ? reason : null,
          }

          if (listApprovalStatus === 'declined') {
            showToaster({ messageId: 'listApprovalStatus', toasterType: 'success' });
            const { data } = await client.mutate({
              mutation: createHistory,
              variables: {
                listId,
                userId: listDetails.userId,
                status: "declined",
                reason: reason,
              }
            });

            let notifyContent = {
              screenType: "becomeahost",
              userType: 'host',
              listId,
              userId: listDetails.userId,
              userName: listDetails.user.profile.firstName,
              listTitle: listDetails.title,
              reason,
              listingStatus: 'declined'
            };

            sendNotifications({ actionType: 'listDeclined', notifyContent, notifyUserId: listDetails.userId, lang : listDetails?.user?.profile?.preferredLanguage });
            sendEmail(listDetails.user.email, 'adminListReject', content);

          } else {
            showToaster({ messageId: 'listingApprove', toasterType: 'success' })
            const { data } = await client.mutate({
              mutation: createHistory,
              variables: {
                listId,
                userId: listDetails.userId,
                status: "approved",
              }
            });

            let notifyContent = {
              screenType: "becomeahost",
              userType: 'host',
              listId,
              userId: listDetails.userId,
              userName: listDetails.user.profile.firstName,
              listTitle: listDetails.title,
              listingStatus: 'approved'
            };
            sendNotifications({ actionType: 'listApproved', notifyContent, notifyUserId: listDetails.userId, lang : listDetails?.user?.profile?.preferredLanguage });
            sendEmail(listDetails.user.email, 'adminListApprove', content);
          }
        }
        dispatch({
          type: MANANGE_LISTING_PUBLISH_STATUS_SUCCESS,
          payload: {
            listingSteps: data.showListingSteps,
            publishListLoading: false
          }
        });
      } else {
        showToaster({ messageId: 'actionFailed', toasterType: 'error' })
        dispatch({
          type: MANANGE_LISTING_PUBLISH_STATUS_ERROR,
          payload: {
            publishListLoading: false
          }
        });
      }

    } catch (error) {
      dispatch({
        type: MANANGE_LISTING_PUBLISH_STATUS_ERROR,
        payload: {
          error,
          publishListLoading: false
        }
      });
    }
  };
}
